export default "__VITE_ASSET__ad60297c__"